import React, { useEffect, useState, useContext } from 'react'
import PdfIcon from '../assets/icon_pdf_file.svg'
import { toast } from 'react-hot-toast'
import axios from 'axios'
import { useSelector } from 'react-redux'
import { saveAs } from 'file-saver';
import { Context } from '../components/context/LanguageWrapper';
import { isDatasheetUploaded } from '../functions/helpers';
import { FormattedMessage } from 'react-intl'

const DatasheetCard = ({ d }) => {

    const context = useContext(Context)

    const userLogin = useSelector(state => state.userLogin)
    const { userDetails } = userLogin

    const userProfile = useSelector(state => state.userProfile)
    const { profile } = userProfile

    const [localProfile, setLocalProfile] = useState('')


    const handleFileDownload = async (doc_id, doc_name) => {

        const headers = {
            headers: {
                "X-AUTH-TOKEN": userDetails.token,
                "content-type": "application/pdf"
            },
            responseType: 'arraybuffer',
        };

        await axios.get(process.env.REACT_APP_API_ENDPOINT + `/technical_sheets/${doc_id}/download/${context.locale.slice(0, 2)}`, headers)
            .then(response => {
                let fileBlob = new Blob([response.data], { type: "application/pdf" });
                if (fileBlob.size < 1000) {
                    toast.error("File mancante")
                } else {
                    saveAs(fileBlob, `${doc_name}.pdf`);
                    toast.success(<FormattedMessage id="app.general.downloaded" defaultMessage="Downloaded" />)
                }
            })
            .catch(error => toast.error(error));
    }

    return (
        <>
            <div className='flex inline-block grid grid-cols-12 bg-gray-200 rounded p-2 hover:border-2 hover:border-green-900'>
                <div className='text-green-900 col-span-2'>
                    <i className="fa-sharp fa-solid fa-file-pdf fa-lg"></i>
                </div>
                <div className='text-green-900 col-span-9 font-bold'>{d.name.toUpperCase()}</div>
                <div className='text-green-900 text-end'>

                    {isDatasheetUploaded(d.pdf_url) ?
                        <button onClick={() => handleFileDownload(d.id, d.name)}>
                            <i className="fa-sharp fa-solid fa-download fa-lg"></i>
                        </button> : ''
                    }
                </div>
            </div>

        </>
    )
}

export default DatasheetCard